import React from "react";
import PropTypes from "prop-types";

function Row({
    row,
    toggleRowExpanded = null,
    trClassName,
    renderRowSubComponent = null,
    print,
    responsiveConfig,
    displayReportView,
}) {
    const responsiveConfigRow =
        responsiveConfig?.type === "ROW" ? "responsive-type-row " : " ";

    return (
        <>
            <div
                {...row.getRowProps({
                    onClick:
                        toggleRowExpanded !== null
                            ? () => {
                                  toggleRowExpanded(row.id);
                              }
                            : null,
                })}
                className={
                    trClassName +
                    (toggleRowExpanded !== null ? " cursor-pointer " : " ") +
                    (row.index % 2 === 0 ? "even " : "odd ") +
                    (row.index === 0 ? "first " : "") +
                    (responsiveConfig?.type === "COLUMN"
                        ? "responsive-type-column "
                        : responsiveConfigRow)
                }
            >
                {row.cells.map((cell) => {
                    return (
                        <div
                            {...cell.getCellProps()}
                            className={
                                "td" +
                                (cell.column.className
                                    ? " " + cell.column.className
                                    : "")
                            }
                        >
                            {responsiveConfig?.type === "ROW" ? (
                                <div className="row">
                                    <div className="col mobile-cell-header">
                                        <div>
                                            {cell.column.render("Header")}
                                        </div>
                                    </div>
                                    <div
                                        className="col"
                                        disabled={
                                            !displayReportView ? true : false
                                        }
                                    >
                                        {cell.render("Cell")}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div
                                        className="mobile-cell-header"
                                        tabIndex={0}
                                    >
                                        {cell.column.render("Header")}
                                    </div>

                                    <div
                                        className="column-cell-content"
                                        tabIndex={0}
                                    >
                                        {cell.render("Cell")}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>

            {(row.isExpanded || print === true) &&
                renderRowSubComponent !== null && (
                    <div role="row" className={trClassName}>
                        {renderRowSubComponent({ row })}
                    </div>
                )}
        </>
    );
}

Row.propTypes = {
    row: PropTypes.shape({
        getRowProps: PropTypes.func.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        index: PropTypes.number.isRequired,
        cells: PropTypes.arrayOf(
            PropTypes.shape({
                getCellProps: PropTypes.func.isRequired,
                column: PropTypes.shape({
                    render: PropTypes.func.isRequired,
                }).isRequired,
                render: PropTypes.func.isRequired,
            })
        ).isRequired,
        isExpanded: PropTypes.bool,
    }).isRequired,
    toggleRowExpanded: PropTypes.func,
    trClassName: PropTypes.string,
    renderRowSubComponent: PropTypes.func,
    print: PropTypes.bool,
    responsiveConfig: PropTypes.shape({
        type: PropTypes.string,
    }),
    displayReportView: PropTypes.bool,
};

export default Row;
